<template>
  <div class="order-submission">
    <div
      class="allAddress"
      :style="store_self_mention ? '' : 'padding-top: 0.2rem'"

    v-if="shipping_type === 0"
    >
      <div class="nav acea-row">
        <div
          class="item font-color-red"
          :class="shipping_type === 0 ? 'on' : 'on2'"
          @click="addressType(0)"
          v-if="store_self_mention"
        ></div>
        <div
          class="item font-color-red"
          :class="shipping_type === 1 ? 'on' : 'on2'"
          @click="addressType(1)"
          v-if="store_self_mention"
        ></div>
      </div>
      <div
        class="address acea-row row-between-wrapper"
        v-if="shipping_type === 0"
        @click="addressTap"
      >
        <div class="addressCon" v-if="addressInfo.real_name">
          <div class="name">
            {{ addressInfo.real_name }}
            <span class="phone">{{ addressInfo.phone }}</span>
          </div>
          <div>
            <span class="default font-color-red" v-if="addressInfo.is_default"
              >[默认]</span
            >
            {{ addressInfo.province }}{{ addressInfo.city}}{{ addressInfo.district }}{{ addressInfo.detail }}
          </div>
        </div>
        <div class="addressCon" v-else>
          <div class="setaddress">设置收货地址</div>
        </div>
        <div class="iconfont icon-jiantou"></div>
      </div>
      <div
        class="address acea-row row-between-wrapper"
        v-else
        @click="showStoreList"
      >
        <div class="addressCon">
          <div class="name" v-if="storeItem">
            {{ storeItem.name }}
            <span class="phone" v-text="storeItem.phone"></span>
          </div>
          <div
            v-text="storeItem.address + ',' + storeItem.detailed_address"
            v-if="storeItem && storeItem.address && storeItem.detailed_address"
          ></div>
        </div>
        <div class="iconfont icon-jiantou"></div>
      </div>
      <div class="line">
        <img src="@assets/images/line.jpg" />
      </div>
    </div>
    <OrderGoods :evaluate="0" :cartInfo="orderGroupInfo.cartInfo"></OrderGoods>
    <div class="wrapper">
      <div
        class="item acea-row row-between-wrapper"
        @click="couponTap"
        v-if="deduction === false"
      >
        <div>优惠券</div>
        <div class="discount">
          {{ usableCoupon.coupon_title || "请选择" }}
          <span class="iconfont icon-jiantou"></span>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="de_safe_money === false">
        <div>赠送积分抵扣</div>
        <div class="discount">
          <div class="select-btn">
            <div class="checkbox-wrapper">
              <label class="well-check">
                <input type="checkbox" v-model="useSafeMoney" />
                <i class="icon"></i>
                <span class="integral">
                  当前赠送积分
                  <span class="num font-color-red" style="margin-right:0.6rem;">
                    {{ userInfo.safe_money || 0 }}&#8194;
                  </span>
                  <br />
                  <span class="num font-color-red" style="margin-right:0.4rem;">最大可抵扣{{de_safe_money_max}}</span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="de_reset_money === false">
        <div>复消积分抵扣</div>
        <div class="discount">
          <div class="select-btn">
            <div class="checkbox-wrapper">
              <label class="well-check">
                <input type="checkbox" v-model="useResetMoney" />
                <i class="icon"></i>
                <span class="integral">
                  当前复消积分
                  <span class="num font-color-red">
                    {{ userInfo.reset_money || 0 }}&#8194;
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="de_point_money === false">
        <div>购物券抵扣</div>
        <div class="discount">
          <div class="select-btn">
            <div class="checkbox-wrapper">
              <label class="well-check">
                <input type="checkbox" v-model="usePointMoney" />
                <i class="icon"></i>
                <span class="integral">
                  当前购物券
                  <span class="num font-color-red">
                    {{ userInfo.point_money || 0 }}&#8194;
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="item acea-row row-between-wrapper" v-if="de_account_money === false">
        <div>积分账户抵扣</div>
        <div class="discount">
          <div class="select-btn">
            <div class="checkbox-wrapper">
              <label class="well-check">
                <input type="checkbox" v-model="useAccountMoney" />
                <i class="icon"></i>
                <span class="integral">
                  当前积分账户
                  <span class="num font-color-red">
                    {{ userInfo.account_money || 0 }}&#8194;
                  </span>
                  <!--<br />
                  最大可抵扣{{de_account_money_max}}-->
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="item acea-row row-between-wrapper" v-if="de_bonus_money === false">
        <div>佣金账户抵扣</div>
        <div class="discount">
          <div class="select-btn">
            <div class="checkbox-wrapper">
              <label class="well-check">
                <input type="checkbox" v-model="useBonusMoney" />
                <i class="icon"></i>
                <span class="integral">
                  当前佣金账户
                  <span class="num font-color-red">
                    {{ userInfo.bonus_money || 0 }}&#8194;
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="item acea-row row-between-wrapper" v-if="de_send_shop_money === false">
        <div>现金账户抵扣</div>
        <div class="discount">
          <div class="select-btn">
            <div class="checkbox-wrapper">
              <label class="well-check">
                <input type="checkbox" v-model="useSendShopMoney" />
                <i class="icon"></i>
                <span class="integral">
                  当前现金账户
                  <span class="num font-color-red">
                    {{ userInfo.send_shop_money || 0 }}&#8194;
                  </span>

                </span>
              </label>
            </div>
            <span v-if="de_send_shop_money_min>0">最低抵扣{{de_send_shop_money_min}}</span>
          </div>
        </div>
      </div>


      <div
        class="item acea-row row-between-wrapper"
        v-if="
          orderGroupInfo.priceGroup.vipPrice > 0
        "
      >
        复购优惠
        <div class="discount">-￥{{ orderGroupInfo.priceGroup.vipPrice }}</div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="shipping_type === 0">
        <div>快递费用</div>
        <div class="discount">
          {{
            orderPrice.pay_postage > 0
              ? "￥" + orderPrice.pay_postage
              : "免运费"
          }}
        </div>
      </div>

      <div class="item acea-row row-between-wrapper" v-if="spread_account_show==1">
        <div>升级人编号</div>
        <div class="discount">
          <input
                  type="text"
                  placeholder="请填写您的升级人编号"
                  style="text-align: right;"
                  v-model="spread_account"

                  @input="check_spread_account"


          />
        </div>


      </div>
      <div class="item acea-row row-between-wrapper" style="background-color:#f1f1f1;" v-if="spread_account_show==1">
        <div>升级人姓名</div>
        <div class="discount" >{{spread_real_name}}</div>
      </div>
      <div v-else>


        <div class="item acea-row row-between-wrapper" style="background-color:#f1f1f1;" v-if="spread_account_show==2">
          <div>推荐人姓名</div>
          <div class="discount" >{{spread_real_name}}</div>
        </div>
        <div class="item acea-row row-between-wrapper"  v-if="spread_account_show==2">
          <div>学瞳联系人</div>
          <div class="discount">
            <input
              type="text"
              placeholder="请填写学瞳的联系姓名"
              style="text-align: right;"
              v-model="contacts"
              maxlength="12"
            />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper"  v-if="spread_account_show==2">
          <div>学瞳联系电话</div>
          <div class="discount">
            <input
              type="text"
              placeholder="请填写学瞳的联系电话"
              style="text-align: right;"
              v-model="contactsTel"
              maxlength="11"
            />
          </div>
        </div>
      </div>

      <!--<div class="item acea-row row-between-wrapper" >
        <div>门店发货</div>
        <div class="discount">
            <input
                    style="margin-right:0.5rem;width: 6rem;"
                    type="text"
                    placeholder="填写门店会员号（或取消右边勾选）"
                    v-model="shop_account"
            />
          <div class="select-btn">
            <div class="checkbox-wrapper">
              <label class="well-check">
                <input type="checkbox" v-model="delivery_shop"  />
                <i class="icon" style="top: -0.15rem;"></i>

              </label>
            </div>
          </div>
        </div>
      </div>-->
      <div class="item acea-row row-between-wrapper" v-if="is_look_pay_pwd==1">
        <div>支付密码</div>
        <div class="discount">
          <input type="password" style="display: none;" />
          <input
              type="password"
              placeholder="请填写您的支付密码"
              v-model="pay_pwd" maxlength="6" style="text-align:right;"
              autocomplete="new-password"
          />
        </div>
      </div>
      <div class="item">
        <div>备注信息</div>
        <textarea
                placeholder="请添加备注（150字以内）"
                v-model="mark"
        ></textarea>
      </div>
    </div>
    <div class="wrapper" style="display:none;">
      <div class="item">
        <div>支付方式</div>
        <div class="list">
          <div
            class="payItem acea-row row-middle"
            :class="active === 'weixin' ? 'on' : ''"
            @click="payItem('weixin')"
            v-show="isWeixin"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-weixin2"
                :class="active === 'weixin' ? 'bounceIn' : ''"
              ></div>
              微信支付
            </div>
            <div class="tip">微信快捷支付</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'weixin' ? 'on' : ''"
            @click="payItem('weixin')"
            v-show="!isWeixin"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-weixin2"
                :class="active === 'weixin' ? 'bounceIn' : ''"
              ></div>
              微信支付
            </div>
            <div class="tip">微信快捷支付</div>
          </div>
          <!--<div
            class="payItem acea-row row-middle"
            :class="active === 'yue' ? 'on' : ''"
            @click="payItem('yue')"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-icon-test"
                :class="active === 'yue' ? 'bounceIn' : ''"
              ></div>
              余额支付
            </div>
            <div class="tip">可用余额：{{ userInfo.now_money || 0 }}</div>
          </div>-->
          <!--<div
            class="payItem acea-row row-middle"
            :class="active === 'offline' ? 'on' : ''"
            @click="payItem('offline')"
            v-if="
              offlinePayStatus === 1 &&
                deduction === false &&
                shipping_type === 0
            "
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-yinhangqia"
                :class="active === 'offline' ? 'bounceIn' : ''"
              ></div>
              线下支付
            </div>
            <div class="tip">线下方便支付</div>
          </div>-->
        </div>
      </div>
    </div>
    <div class="moneyList">
      <div
        class="item acea-row row-between-wrapper" v-if="orderPrice.total_price !== undefined" >
        <div>商品总价：</div>
        <div class="money">￥{{ orderPrice.total_price }}</div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="orderPrice.all_point_money>0" >
        <div>商品购物券：</div>
        <div class="money">{{ orderPrice.all_point_money }}</div>
      </div>


      <div class="item acea-row row-between-wrapper" v-if="orderPrice.show_all_pv >0" >
        <div>订单业绩：</div>
        <div class="money">{{ orderPrice.show_all_pv }}pv</div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="orderPrice.givePointMoney > 0" >
        <div>赠送购物券：</div>
        <div class="money">{{ orderPrice.givePointMoney }}</div>
      </div>
      <!--<div
      class="item acea-row row-between-wrapper"v-if="orderPrice.growth !== undefined" >
        <div>分红剩余：</div>
        <div class="money">{{ orderPrice.growth }}</div>
      </div>

      <div class="item acea-row row-between-wrapper"v-if="orderPrice.show_all_pv !== undefined" >
        <div>总C（未扣减分红剩余）：</div>
        <div class="money">{{ orderPrice.show_all_pv }}C</div>
      </div>
      <div class="item acea-row row-between-wrapper"v-if="orderPrice.show_total_pv !== undefined" >
        <div>商品总C：</div>
        <div class="money">{{ orderPrice.show_total_pv }}C</div>
      </div>
      <div class="item acea-row row-between-wrapper"v-if="orderPrice.show_remove_pv !== undefined" >
        <div>分红剩余扣减C：</div>
        <div class="money">{{ orderPrice.show_remove_pv }}C</div>
      </div>-->
      <div class="item acea-row row-between-wrapper"  >
        <div>运费：</div>
        <div class="money">+￥{{ orderPrice.pay_postage }}</div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="orderPrice.coupon_price > 0">
        <div>优惠券抵扣：</div>
        <div class="money">-￥{{ orderPrice.coupon_price }}</div>
      </div>

      <div class="item acea-row row-between-wrapper"  v-if="orderPrice.de_send_shop_money > 0">
        <div>现金账户抵扣：</div>
        <div class="money">-￥{{ orderPrice.de_send_shop_money }}</div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="orderPrice.de_reset_money > 0">
        <div>复消抵扣：</div>
        <div class="money">-￥{{ orderPrice.de_reset_money }}</div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="orderPrice.de_safe_money > 0">
        <div>分红剩余抵扣：</div>
        <div class="money">-￥{{ orderPrice.de_safe_money }}</div>
      </div>

      <div class="item acea-row row-between-wrapper" v-if="orderPrice.de_account_money > 0" >
        <div>积分账户抵扣：</div>
        <div class="money">-￥{{ orderPrice.de_account_money }}</div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="orderPrice.de_bonus_money > 0" >
        <div>佣金账户抵扣：</div>
        <div class="money">-￥{{ orderPrice.de_bonus_money }}</div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="orderPrice.de_point_money > 0" >
        <div>购物券抵扣：</div>
        <div class="money">-￥{{ orderPrice.de_point_money }}</div>
      </div>
    </div>

    <div style="height:1.2rem"></div>
    <div class="footer acea-row row-between-wrapper">
      <div>
        合计:
        <span class="font-color-red">￥{{ orderPrice.pay_price }}<span v-if="orderPrice.pay_point_money>0">+{{orderPrice.pay_point_money}}购物券</span></span>
      </div>
      <div class="settlement" @click="createOrder">立即结算</div>
    </div>
    <CouponListWindow
      v-on:couponchange="changecoupon($event)"
      v-model="showCoupon"
      :price="orderPrice.total_price"
      :checked="usableCoupon.id"
      :cartid="cartid"
      @checked="changeCoupon"
    ></CouponListWindow>
    <AddressWindow
      @checked="changeAddress"
      @redirect="addressRedirect"
      v-model="showAddress"
      :checked="addressInfo.id"
      ref="mychild"
    ></AddressWindow>
  </div>
</template>
<style scoped>
.order-submission .wrapper .shipping select {
  color: #999;
  padding-right: 0.15rem;
}
.order-submission .wrapper .shipping .iconfont {
  font-size: 0.3rem;
  color: #515151;
}
.order-submission .allAddress {
  width: 100%;
  background-image: linear-gradient(to bottom, #ec5d59 0%, #f5f5f5 100%);
  background-image: -webkit-linear-gradient(
    to bottom,
    #ec5d59 0%,
    #f5f5f5 100%
  );
  background-image: -moz-linear-gradient(to bottom, #ec5d59 0%, #f5f5f5 100%);
  padding-top: 1rem;
}
.order-submission .allAddress .nav {
  width: 7.1rem;
  margin: 0 auto;
}
.order-submission .allAddress .nav .item {
  width: 3.55rem;
}
.order-submission .allAddress .nav .item.on {
  position: relative;
  width: 2.5rem;
}
.order-submission .allAddress .nav .item.on:before {
  position: absolute;
  bottom: 0;
  content: "快递配送";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 3.55rem;
  border-width: 0 0.2rem 0.8rem 0;
  border-style: none solid solid;
  border-color: transparent transparent #fff;
  z-index: 9;
  border-radius: 0.07rem 0.3rem 0 0;
  text-align: center;
  line-height: 0.8rem;
}
.order-submission .allAddress .nav .item:nth-of-type(2).on:before {
  content: "到店自提";
  border-width: 0 0 0.8rem 0.2rem;
  border-radius: 0.3rem 0.07rem 0 0;
}
.order-submission .allAddress .nav .item.on2 {
  position: relative;
}
.order-submission .allAddress .nav .item.on2:before {
  position: absolute;
  bottom: 0;
  content: "到店自提";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 4.6rem;
  border-width: 0 0 0.6rem 0.6rem;
  border-style: none solid solid;
  border-color: transparent transparent #f7c1bd;
  border-radius: 0.4rem 0.06rem 0 0;
  text-align: center;
  line-height: 0.6rem;
}
.order-submission .allAddress .nav .item:nth-of-type(1).on2:before {
  content: "快递配送";
  border-width: 0 0.6rem 0.6rem 0;
  border-radius: 0.06rem 0.4rem 0 0;
}
.order-submission .allAddress .address {
  width: 7.1rem;
  height: 1.5rem;
  margin: 0 auto;
}
.order-submission .allAddress .line {
  width: 7.1rem;
  margin: 0 auto;
}
.order-submission .wrapper .item .discount input::placeholder {
  color: #ccc;
}
</style>
<script>
import OrderGoods from "@components/OrderGoods";
import CouponListWindow from "@components/CouponListWindow";
import AddressWindow from "@components/AddressWindow";
import { postOrderConfirm, postOrderComputed, createOrder,checkSpreadAccount } from "@api/order";
import { storeListApi } from "@api/store";
import { getUser } from "@api/user";
import { pay } from "@libs/wechat";
import { isWeixin2 } from "@utils";
import { mapGetters } from "vuex";
import cookie from "@utils/store/cookie";
const NAME = "OrderSubmission",
  _isWeixin = isWeixin2();
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
export default {
  name: NAME,
  components: {
    OrderGoods,
    CouponListWindow,
    AddressWindow
  },
  props: {},
  computed: {
    ...mapGetters(["storeItems"]),
    storeItem: function() {
      if (JSON.stringify(this.storeItems) == "{}") {
        return this.storeList;
      } else {
        return this.storeItems;
      }
    }
  },
  data: function() {
    return {
      cartid: "",
      offlinePayStatus: 2,
      from: _isWeixin ? "weixin" : "weixinh5",
      deduction: true,
      spread_real_name:'',
      spread_account_show:0,
        de_send_shop_money:true,
        de_send_shop_money_max:0,
      de_send_shop_money_min:0,

        de_account_money:true,
        de_account_money_max:0,
      de_reset_money:true,
        de_safe_money:true,
        de_safe_money_max:0,

        de_bonus_money:true,
        de_point_money:true,
      isWeixin: _isWeixin,
      pinkId: 0,
      active: _isWeixin ? "weixin" : "weixin",//yue
      showCoupon: false,
      showAddress: false,
      addressInfo: {},
      couponId: 0,
      orderGroupInfo: {
        priceGroup: {}
      },
      usableCoupon: {},
      addressLoaded: false,
      useIntegral: false,
        useSendShopMoney:false,
        useAccountMoney:false,
      useResetMoney:false,
      useSafeMoney:false,
      useBonusMoney:false,
        usePointMoney:true,
      orderPrice: {
        pay_price: "计算中",
          pay_point_money:0,
      },
      mark: "",
      system_store: {},
      shipping_type: 0,
      spread_account:cookie.get('order_act_account')?cookie.get('order_act_account'):'',
      contacts: "",
      contactsTel: "",
      store_self_mention: 0,
      userInfo: {},
      storeList: {},
      shop_account:'',
        delivery_shop:false,
      delivery_company:false,
      is_look_pay_pwd:0,
      is_look_pay_pwd_tip:0,
      pay_pwd:'',
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) {
        this.getUserInfo();
        this.getCartInfo();
        this.pay_pwd = '';
        this.spread_account = '';

        var order_act_account = cookie.get('order_act_account');
        if(order_act_account){
          this.spread_account = order_act_account;
        }
      }
    },
    useIntegral() {
      this.computedPrice();
    },

      useSendShopMoney(){
        this.computedPrice();
      },
    useAccountMoney(){
      this.computedPrice();
    },
    useResetMoney(){
      this.computedPrice();
    },
    useSafeMoney(){
      this.computedPrice();
    },
    useBonusMoney(){
      this.computedPrice();
    },
      usePointMoney(){
          this.computedPrice();
      },
    /*,
    shipping_type() {
      this.computedPrice();
    }*/
  },
  mounted: function() {
    let that = this;


    that.pay_pwd = '';
    that.spread_account = '';
    var order_act_account = cookie.get('order_act_account');
    if(order_act_account){
      that.spread_account = order_act_account;
    }

    that.getUserInfo();
    that.getCartInfo();
    //that.getList();
    if (that.$route.query.pinkid !== undefined)
      that.pinkId = that.$route.query.pinkid;
    if (that.$route.params.id !== undefined)
      that.cartid = that.$route.params.id;
  },
  methods: {
    check_spread_account:function(){
      let spread_account = this.spread_account;
      if(spread_account.length>=10){
        checkSpreadAccount({spread_account:spread_account})
                .then(res => {
                  this.spread_real_name = res.data.spread_real_name;
                })
                .catch(res => {
                  this.$dialog.error(res.msg);
                });
      }
    },
    blur_check_spread_account:function(){
      let spread_account = this.spread_account;
      if(spread_account.length<10) {
        //this.$dialog.error('请正确填写激活编号');
      }
    },
    // 获取门店列表数据
    getList: function() {
      let data = {
        latitude: cookie.get(LATITUDE) || "", //纬度
        longitude: cookie.get(LONGITUDE) || "", //经度
        page: 1,
        limit: 10
      };
      storeListApi(data)
        .then(res => {
          this.storeList = res.data.list[0];
        })
        .catch(err => {
          this.$dialog.error(err.msg);
        });
    },
    // 跳转到门店列表
    showStoreList() {
      this.$store.commit("GET_TO", "orders");
      this.$router.push("/shop/storeList/orders");
    },
    getUserInfo() {
      getUser()
        .then(res => {
          this.userInfo = res.data;
        })
        .catch(() => {});
    },
    addressType: function(index) {
      if (index && !this.system_store.id)
        return this.$dialog.error("暂无门店信息，您无法选择到店自提！");
      //this.shipping_type = index;
    },
    computedPrice() {
      let that = this;
      let shipping_type = this.shipping_type;
      postOrderComputed(this.orderGroupInfo.orderKey, {
        addressId: this.addressInfo.id,
        useIntegral: this.useIntegral ? 1 : 0,
          useSendShopMoney:this.useSendShopMoney?1:0,
        useAccountMoney:this.useAccountMoney?1:0,
        useResetMoney:this.useResetMoney?1:0,
        useSafeMoney:this.useSafeMoney?1:0,
          usePointMoney:this.usePointMoney?1:0,
        useBonusMoney:this.useBonusMoney?1:0,
        pay_pwd:this.pay_pwd,
        spread_account:this.spread_account,
        couponId: this.usableCoupon.id || 0,
        shipping_type: parseInt(shipping_type),
        payType: this.active
      })
        .then(res => {
          that.check_spread_account();
          const data = res.data;
          if (data.status === "EXTEND_ORDER") {
            this.$router.replace({
              path: "/order/detail/" + data.result.orderId
            });
          } else {
            this.orderPrice = data.result;
          }
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
    getCartInfo() {
      const cartIds = this.$route.params.id;
      if (!cartIds) {
        //return this.$dialog.error("参数有误");
        //return this.$router.go(-1);
         this.$dialog.toast({ mes: '参数有误' });
        return false;
      }
      let show_account = cookie.get("login_u_account");
      let order_act_account = cookie.get("order_act_account");
      if(order_act_account!=='' && order_act_account!==undefined && order_act_account!=null) show_account = order_act_account;
      postOrderConfirm(cartIds,show_account)
        .then(res => {

          if(res.data.is_look_pay_pwd_tip==1){
            return this.$dialog.error('请先设置支付密码').then(() => {
               this.$router.push({ path: "/pay_password" });
            });
          }

          this.offlinePayStatus = res.data.offline_pay_status;
          this.orderGroupInfo = res.data;
          //this.deduction = res.data.deduction;
          this.is_look_pay_pwd = res.data.is_look_pay_pwd;
          this.shipping_type = res.data.shipping_type;
          this.spread_account_show = res.data.spread_account_show==1 && this.spread_account!=''?1:0;
          //this.spread_account = res.data.spread_account;
          this.spread_real_name = res.data.spread_real_name;

          this.de_send_shop_money = res.data.de_send_shop_money;
          this.de_send_shop_money_max = res.data.de_send_shop_money_max;
          this.de_send_shop_money_min = res.data.de_send_shop_money_min;

          this.de_account_money = res.data.de_account_money;
          //this.useAccountMoney = res.data.de_account_money?0:1;
          this.de_account_money_max = res.data.de_account_money_max;

          this.de_reset_money = res.data.de_reset_money;
          this.de_safe_money = res.data.de_safe_money;
          //this.useSafeMoney = res.data.de_safe_money?0:1;
          this.de_safe_money_max = res.data.de_safe_money_max;

          this.de_bonus_money = res.data.de_bonus_money;
          this.de_point_money = res.data.de_point_money;

          this.usableCoupon = res.data.usableCoupon || {};
          this.addressInfo = res.data.addressInfo || {};
          this.system_store = res.data.system_store || {};
          this.store_self_mention = res.data.store_self_mention;
          this.computedPrice();
        })
        .catch(res => {
                this.$dialog.error(res.msg);
        });
    },
    addressTap: function() {
      this.showAddress = true;
      if (!this.addressLoaded) {
        this.addressLoaded = true;
        this.$refs.mychild.getAddressList();
      }
    },
    addressRedirect() {
      this.addressLoaded = false;
      this.showAddress = false;
    },
    couponTap: function() {
      this.showCoupon = true;
    },
    changeCoupon: function(coupon) {
      if (!coupon) {
        this.usableCoupon = { coupon_title: "不使用优惠券", id: 0 };
      } else {
        this.usableCoupon = coupon;
      }
      this.computedPrice();
    },
    payItem: function(index) {
      this.active = index;
      this.computedPrice();
    },
    changeAddress(addressInfo) {
      this.addressInfo = addressInfo;
      this.computedPrice();
    },
    createOrder() {
      let shipping_type = this.shipping_type;
      if (!this.active) return this.$dialog.toast({ mes: "请选择支付方式" });
      if (!this.addressInfo.id && !this.shipping_type)
        return this.$dialog.toast({ mes: "请选择收货地址" });
      if (this.shipping_type) {
        if (
          (this.contacts === "" || this.contactsTel === "") &&
          this.shipping_type
        )
          return this.$dialog.toast({ mes: "请填写联系人 和 联系人电话" });
        if (!/^1\d{10}$/.test(this.contactsTel)) {
          return this.$dialog.toast({ mes: "请填写正确的手机号" });
        }
        if (!/^[\u4e00-\u9fa5\w]{2,16}$/.test(this.contacts)) {
          return this.$dialog.toast({ mes: "请填写您的真实姓名" });
        }
      }

      /*if(this.delivery_shop){
        if (this.shop_account=='') {
          return this.$dialog.toast({ mes: "请填写发货门店会员号" });
        }
      }*/


      /*if(this.pay_pwd=='' &&
              (
                (this.orderPrice.de_send_shop_money>0) ||
                (this.orderPrice.de_account_money>0) ||
                (this.orderPrice.de_reset_money>0) ||
                (this.orderPrice.de_safe_money>0) ||
                (this.orderPrice.de_bonus_money>0) ||
                (this.orderPrice.de_point_money>0)
              )
      )
      {
        return this.$dialog.toast({ mes: "请填写支付密码" });
      }*/


      this.$dialog.loading.open("生成订单中");
      createOrder(this.orderGroupInfo.orderKey, {
        real_name: this.contacts,
        phone: this.contactsTel,
        addressId: this.addressInfo.id,
        useIntegral: this.useIntegral ? 1 : 0,
          useBonusMoney:this.useBonusMoney?1:0,
          useSendShopMoney:this.useSendShopMoney?1:0,
        useAccountMoney:this.useAccountMoney?1:0,
        useResetMoney:this.useResetMoney?1:0,
        useSafeMoney:this.useSafeMoney?1:0,
        spread_account:this.spread_account,
        pay_pwd:this.pay_pwd,

          usePointMoney:this.usePointMoney?1:0,
        couponId: this.usableCoupon.id || 0,
        payType: this.active,
        pinkId: this.pinkId,
        seckill_id: this.orderGroupInfo.seckill_id,
        combinationId: this.orderGroupInfo.combination_id,
        bargainId: this.orderGroupInfo.bargain_id,
        from: this.from,
        mark: this.mark || "",
        //shipping_type: parseInt(shipping_type) + 1,
        store_id: this.storeItem ? this.storeItem.id : 0,
        delivery_shop:this.delivery_shop?1:0,
        shop_account:this.shop_account
      })
        .then(res => {
          this.$dialog.toast({ mes: 11 });
          cookie.remove('order_act_account');
          this.$dialog.loading.close();
          const data = res.data;
          let url = "/order/status/" + data.result.orderId;
          switch (data.status) {
            case "ORDER_EXIST":
            case "EXTEND_ORDER":
            case "PAY_DEFICIENCY":
            case "PAY_ERROR":
              this.$dialog.toast({ mes: res.msg });
              this.$router.replace({
                path: url + "/0?msg=" + res.msg
              });
              break;
            case "SUCCESS":
              this.$dialog.success(res.msg);
              this.$router.replace({
                path: url + "/1"
              });
              break;
            case "WECHAT_H5_PAY":
              this.$router.replace({
                path: url + "/2"
              });
              setTimeout(() => {
                location.href = data.result.jsConfig.mweb_url;
              }, 100);
              break;
            case "WECHAT_PAY":
              pay(data.result.jsConfig).finally(() => {
                this.$router.replace({
                  path: url + "/4"
                });
              });
          }
        })
        .catch(err => {
          this.$dialog.toast({ mes: err.msg });
          this.$dialog.loading.close();
          /*this.$dialog.error(err.msg || "创建订单失败");
          this.$dialog.loading.close();*/
          //this.$router.go(-1);
        });
    }
  }
};
</script>
